// src/components/ui/InfoTooltip.jsx
import React from 'react';
import { HelpCircle } from 'lucide-react';

function InfoTooltip({ text }) {
    return (
        <div className="relative inline-flex items-center ml-2 z-50">
            <HelpCircle className="peer w-4 h-4 text-zinc-500 hover:text-emerald-400 cursor-help transition-colors" />

            {/* Hover olunca açılan karanlık kutucuk */}
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-56 p-3 bg-[#09090b] border border-emerald-900/50 rounded-sm opacity-0 invisible peer-hover:opacity-100 peer-hover:visible transition-all duration-200 pointer-events-none shadow-xl shadow-emerald-900/10 transform peer-hover:-translate-y-1 z-50">
                <p className="text-[11px] leading-relaxed text-zinc-300 font-mono text-center">
                    {text}
                </p>
                {/* Kutucuğun altındaki küçük ok */}
                <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-emerald-900/50"></div>
            </div>
        </div>
    );
}

export default InfoTooltip;